import { tv } from "@utils/tw"
import { AnimatePresence, motion } from "motion/react"
import { lazy, ReactElement } from "react"

export type BadgeProps = {
  label?: string | number
  dot?: boolean
  enabled?: boolean
  children: ReactElement
}

export function Badge(props: BadgeProps) {
  const styles = badgeStyles({
    dot: props.dot,
  })
  const label = props.dot ? null : props.label
  return (
    <div className={styles.wrapper()}>
      <AnimatePresence>
        {props.enabled !== false && (
          <motion.span
            key={label}
            initial={{ scale: 0 }}
            animate={{ scale: 1 }}
            exit={{ scale: 0 }}
            className={styles.label()}
          >
            {label}
          </motion.span>
        )}
      </AnimatePresence>
      {props.children}
    </div>
  )
}

const badgeStyles = tv({
  slots: {
    wrapper: "relative z-[1]",
    label:
      "absolute -right-1 -top-1 bg-red z-[2] text-white type-caption rounded-sm text-[10px] px-[0.4em] pointer-events-none",
  },
  variants: {
    dot: {
      true: {
        label: "w-3 h-3 right-0 top-0 transform translate-x-1/3 -translate-y-1/3 rounded-full",
      },
    },
  },
})
